<template>
  
  <div class="group" :ref="refs[builder.wallSpace.fieldName + 'Group']">

    <div class="group-header">
      <div class="group-title" :id="`${builder.wallSpace.fieldName}Title`">Where are your walls?</div>
    </div>

    <Plan-Selector
      :key=builder.wallSpace.fieldName
      :field-name=builder.wallSpace.fieldName
      :display-type=builder.wallSpace.displayType
      :options=builder.wallSpace.options
      :selected=builder.currentItem.specs[builder.wallSpace.fieldName]
      options-source="wallSpaceOptions"
      scope="specs"
      @select-option="select"
    ></Plan-Selector>

  </div>
  
</template>

<script setup>
  
import { ref } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

function select(prop, opt) {
  builder.setCurrentItemSpec(prop, opt['id']);

  // one-click continue
  builder.saveCurrentItem(true); 
}

// init refs
let refHandles = [
  builder.wallSpace.fieldName + 'Group',
];
const refs = _.chain(refHandles).keyBy().mapValues(ref).value();
refHandles.forEach(item => {
  builder.refs[item] = refs[item];
});
</script>